<label class="label" [attr.for]="id + '__input'">
  <span class="label__illustration">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.71429 2H24.0221C24.3768 2 24.72 2.12568 24.9908 2.35474L35.4687 11.2173C35.8057 11.5023 36 11.9212 36 12.3625V38.1667C36 41.7478 35.9591 42 32.2857 42H9.71429C6.0409 42 6 41.7478 6 38.1667V5.83333C6 2.25225 6.0409 2 9.71429 2ZM14 25C14 24.4477 14.4477 24 15 24H31C31.5523 24 32 24.4477 32 25V27C32 27.5523 31.5523 28 31 28H15C14.4477 28 14 27.5523 14 27V25ZM15 32C14.4477 32 14 32.4477 14 33V35C14 35.5523 14.4477 36 15 36H23C23.5523 36 24 35.5523 24 35V33C24 32.4477 23.5523 32 23 32H15Z"
        fill="#FC5A5A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.7143 6H30.0221C30.3768 6 30.72 6.12568 30.9908 6.35474L41.4687 15.2173C41.8057 15.5023 42 15.9212 42 16.3625V42.1667C42 45.7478 41.9591 46 38.2857 46H13.7143C10.0409 46 10 45.7478 10 42.1667V9.83333C10 6.25225 10.0409 6 13.7143 6ZM14 25C14 24.4477 14.4477 24 15 24H31C31.5523 24 32 24.4477 32 25V27C32 27.5523 31.5523 28 31 28H15C14.4477 28 14 27.5523 14 27V25ZM15 32C14.4477 32 14 32.4477 14 33V35C14 35.5523 14.4477 36 15 36H23C23.5523 36 24 35.5523 24 35V33C24 32.4477 23.5523 32 23 32H15Z"
        fill="#4b45b2"
      />
    </svg>

    <span class="caption">{{ caption || defaultCaption }}</span>
  </span>

  <span class="label__seperator">ou</span>

  <button class="label__cta" (click)="fileInputRef.click()" type="button" mat-raised-button>
    {{ labelCta }}
  </button>

  @if (accept) {
    <p class="label__hint">{{ labelHint }} {{ accept | fileType: ' / ' }}</p>
  }
</label>

<input
  class="file-input"
  #fileInputRef
  [attr.id]="id + '__input'"
  [attr.multiple]="multiUpload ? '' : null"
  [accept]="computedAccept"
  (change)="onFilesInput($event)"
  tabindex="-1"
  type="file"
/>
